document.addEventListener('click', function(event) {
  const trigger = event.target.closest('.product-tabs__trigger');
  if (!trigger || trigger.classList.contains('is-active')) return;

  const section = trigger.closest('.product-tabs-section');
  const handle = trigger.dataset.tabHandle;

  section.querySelectorAll('[data-tab-content]').forEach(panel => {
    panel.style.display = panel.dataset.tabContent === handle ? '' : 'none';
  });

  section.querySelectorAll('[data-tab-cta]').forEach(cta => {
    cta.style.display = cta.dataset.tabCta === handle ? '' : 'none';
  });

  section.querySelectorAll('.product-tabs__trigger').forEach(btn => {
    const isActive = btn.dataset.tabHandle === handle;
    btn.classList.toggle('is-active', isActive);
    btn.setAttribute('aria-selected', String(isActive));
  });

  const activePanel = section.querySelector(`[data-tab-content="${handle}"]`);
  activePanel?.querySelectorAll('[data-carousel]').forEach(function(carousel) {
    initCarousel(carousel);
  });
});